import React, { useState, useEffect } from "react";
import projectsImg from "../../../utilities/background-images/projects.jpg";
import styles from "./ProjectsPage.module.css";
import getKeyData from "../../../utilities/functions/findObjKeyData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataContext } from "../../../store/DataContext";
import Options from "./options/Options";

const ProjectsPage = (props) => {
	const [showOptions, toggleOptions] = useState(false);
	const [clickedProject, setClickedProject] = useState(null);

	useEffect(() => {
		props.fetchAllProjects();
		//eslint-disable-next-line
	}, []);

	if (props.projects) {
		let activeProjects = props.projects;
		let breadCrumbData = null;

		if (props.active) {
			const keyData = getKeyData(props.projects, props.active);
			activeProjects = keyData[0].projects;
			breadCrumbData = keyData[1];
		}

		const transformedProjects = (
			<div className={styles.chunk}>
				{activeProjects.map((project, j) => {
					if (project.link) {
						const clicked = () => {
							if (!project.private || props.login.status) {
								window.open(project.link);
							} else {
								if (!props.login.show) {
									props.toggleLoginPanel();
								}
							}
						};

						let check =
							showOptions && project.name + "_" + j === clickedProject;
						return (
							<div
								key={project.name + "_" + j}
								className={styles.project}
								onClick={(e) => {
									e.preventDefault();
									clicked();
								}}
								onMouseDown={(e) => {
									if (e.button === 1) {
										e.preventDefault();
										clicked();
									}
								}}
							>
								{check ? (
									<Options
										toggleOptions={toggleOptions}
										clicked={clicked}
										link={project.link}
									/>
								) : null}
								{project.image ? (
									<img
										src={require(`../../../utilities/project-images/${project.image}`)}
										alt={""}
										className={styles.projectImg}
										onContextMenu={(e) => {
											e.preventDefault();
											setClickedProject(project.name + "_" + j);
											toggleOptions(true);
										}}
									/>
								) : null}
								<div className={styles.projectText}>
									{project.name}
									<div className={styles.projectIn}>
										{!project.private ? null : (
											<FontAwesomeIcon
												icon={props.login.status ? "unlock" : "lock"}
											/>
										)}
									</div>
								</div>
							</div>
						);
					} else {
						const clicked = () => {
							if (!project.private || props.login.status) {
								props.changeActiveProjectHandler(project.id);
							} else {
								if (!props.login.show) {
									props.toggleLoginPanel();
								}
							}
						};

						return (
							<div
								key={project.name + "_" + j}
								className={styles.project}
								onClick={clicked}
							>
								{project.image ? (
									<img
										src={require(`../../../utilities/project-images/${project.image}`)}
										alt={""}
										className={styles.projectImg}
										onContextMenu={(e) => {
											e.preventDefault();
										}}
									/>
								) : null}
								<div className={styles.projectText}>
									{project.name}
									<div className={styles.projectIn}>
										{!project.private ? null : (
											<FontAwesomeIcon
												icon={props.login.status ? "unlock" : "lock"}
											/>
										)}
										<FontAwesomeIcon icon="folder" />
									</div>
								</div>
							</div>
						);
					}
				})}
			</div>
		);

		const breadCrumbDiv = (
			<div className={styles.breadcrumb}>
				<span
					className={styles.breadcrumb__step}
					onClick={() => {
						props.changeActiveProjectHandler(null);
					}}
				>
					Home
				</span>
				{breadCrumbData ? (
					<>
						{breadCrumbData.map((data, i) => {
							let classes = [styles.breadcrumb__step];
							if (i === breadCrumbData.length - 1) {
								classes.push(styles.breadcrumb__step__active);
							}
							return (
								<span
									key={data.id}
									className={classes.join(" ")}
									onClick={() => {
										props.changeActiveProjectHandler(data.id);
									}}
								>
									{data.name}
								</span>
							);
						})}
					</>
				) : null}
			</div>
		);
		return (
			<div
				id="Projects"
				className={styles.main}
				style={{ backgroundImage: `url(${projectsImg})` }}
			>
				{breadCrumbDiv}
				{transformedProjects}
			</div>
		);
	} else {
		return <></>;
	}
};

export default (props) => (
	<DataContext.Consumer>
		{(mainConsumer) => <ProjectsPage {...mainConsumer} {...props} />}
	</DataContext.Consumer>
);
